<template>
  <v-row class="contest-card running-card">
    <v-col md="12">
      <v-card class="elevation-0 pa-0 rounded-0 running-card-wrapper"
        :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
        <v-img height="172px" src="@/assets/contest-card.png">
          <div style="visibility: hidden;" class="text-right pt-2 pr-2">
            <v-menu rounded="0" transition="slide-x-transition" bottom left>
              <template v-slot:activator="{ attrs, on }">
                <v-btn small tile elevation="0" class="ma-0 text-capitalize btn-account" v-bind="attrs" v-on="on" icon>
                  <v-icon color="#fff">mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
            </v-menu>
          </div>
          <div class="contest-details-wrapper">
            <div class="content">
              <div class="title mb-3">
                <h3>Contest {{ contest?.id || '' }}</h3>
                <p>{{ contest?.contest_name }}</p>
              </div>
              <div class="price">
                <h3>Total Price Worth</h3>
                <h4>$<span>{{ contest?.total_prize_worth }}</span></h4>
              </div>
            </div>
            <div class="prize-wrapper">
              <div class="prize" v-if="contest?.first_prize">
                <div class="prize-label">
                  <v-img height="16px" width="23px" src="@/assets/cup.png"></v-img>
                  <span class="number">1</span>
                </div>
                <div class="prize-amount">
                  <h5><span>{{ contest?.first_prize }}</span></h5>
                </div>
              </div>
              <div class="prize" v-if="contest?.second_prize">
                <div class="prize-label">
                  <v-img height="16px" width="23px" src="@/assets/cup.png"></v-img>
                  <span class="number">2</span>
                </div>
                <div class="prize-amount">
                  <h5><span>{{ contest?.second_prize }}</span></h5>
                </div>
              </div>
              <div class="prize" v-if="contest?.third_prize">
                <div class="prize-label">
                  <v-img height="16px" width="23px" src="@/assets/cup.png"></v-img>
                  <span class="number">3</span>
                </div>
                <div class="prize-amount">
                  <h5><span>{{ contest?.third_prize }}</span></h5>
                </div>
              </div>
            </div>
          </div>
        </v-img>
        <div class="card-content">
          <v-card-actions class="pb-3">
            <v-row align="center">
              <v-col cols="12" sm="6">
                <h2 class="bg-danger">Finished Contest</h2>
              </v-col>
              <v-col cols="12" sm="6">
                <h3>Contestant : <span>{{ contest?.total_contestants || 0 }}</span></h3>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-actions class="content-header custom-border-bottom">
            <h5 class="mb-2">{{ contest?.contest_name }}</h5>
            <p>{{ contest?.instruction }}</p>
          </v-card-actions>
          <v-card-actions class="pt-4">
            <v-row align="center">
              <v-col cols="12" sm="6">
                <div class="currency-leverage">
                  <span>Deposit Amount</span>
                  <span>${{ contest?.contest_money }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="currency-leverage">
                  <span>Total Price Worth</span>
                  <span>${{ contest?.total_prize_worth }}</span>
                </div>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-actions class="custom-border-bottom">
            <v-row align="center">
              <v-col cols="12" sm="6">
                <div class="currency-leverage">
                  <span>Start Time </span>
                  <span>{{ contest?.formatted_start_date }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="currency-leverage">
                  <span>End Time</span>
                  <span>{{ contest?.formatted_end_date }}</span>
                </div>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-actions>
            <v-row align="center">
              <v-col cols="12" sm="6">
                <div class="currency-leverage" v-if="contest?.first_prize">
                  <span>1st Prize</span>
                  <span>{{ `${contest.prize_type === 0 ? '$' : ''}${contest?.first_prize}` }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="6" v-if="contest?.second_prize">
                <div class="currency-leverage">
                  <span>2nd Prize</span>
                  <span>{{ `${contest.prize_type === 0 ? '$' : ''}${contest?.second_prize}` }}</span>
                </div>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-actions>
            <v-row align="center">
              <v-col cols="12" sm="6" v-if="contest?.third_prize">
                <div class="currency-leverage">
                  <span>3rd Prize </span>
                  <span>{{ `${contest.prize_type === 0 ? '$' : ''}${contest?.third_prize}` }}</span>
                </div>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-actions>
            <v-row align="center">
              <v-col cols="12" sm="6">
                <div class="currency-leverage">
                  <span>Account Type</span>
                  <span>{{ contest?.account_type || "N/A" }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="currency-leverage">
                  <span>Start in Hours</span>
                  <span>{{ contest?.startInHours }}</span>
                </div>
              </v-col>
            </v-row>
          </v-card-actions>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    contest: {
      type: Object,
      required: true
    }
  },
}

</script>